import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Hana from '../Assets/Hana.jpg';
import G1 from '../Assets/G1.jpg';
import G2 from '../Assets/G2.jpg';
import G3 from '../Assets/G3.jpg';
import G4 from '../Assets/G4.jpg';
import G5 from '../Assets/G5.jpg';
import G6 from '../Assets/G6.jpg';
import G7 from '../Assets/G7.jpg';
const images = [G4, G1, G3, Hana, G2, G5, G6, G7];
export default function PhotoGallery() {
  const [start, setStart] = useState(0);
  return <div role="region" aria-label="Community photo gallery">
    <div className="gallery-grid">{[0, 1, 2].map(offset => <img key={offset} src={images[(start + offset) % images.length]} alt={`Life at Rehoboth — community gathering ${(start + offset) % images.length + 1}`} loading="lazy" />)}</div>
    <div className="gallery-footer"><span aria-live="polite">Life at Rehoboth <span aria-hidden="true">/</span> {String(start + 1).padStart(2, '0')} of {String(images.length).padStart(2, '0')}</span><div className="gallery-controls"><button aria-label="Previous photo" onClick={() => setStart((start + images.length - 1) % images.length)}><ChevronLeft size={18} /></button><button aria-label="Next photo" onClick={() => setStart((start + 1) % images.length)}><ChevronRight size={18} /></button></div></div>
  </div>;
}
